import type { AppNotificationData } from './notifications-api'

export function notificationTarget(data: AppNotificationData): string | null {
  if (data.type.startsWith('conversation.') && data.project_id && data.conversation_id) {
    return `/projects/${data.project_id}/conversations?conversation=${data.conversation_id}`
  }

  if (data.type.startsWith('billing.')) {
    return '/billing'
  }

  if (data.type.startsWith('knowledge.') && data.project_id) {
    return `/projects/${data.project_id}/knowledge`
  }

  return null
}
